import axios, { AxiosRequestConfig } from 'axios';
import { combineBaseReq, checkHttpResponse } from 'app/bff/services/transferService';
import { BaseResp, SortPageReq } from 'app/bff/models/base';
import { AaGetcaptchaReq, AaGetcaptchaResp } from 'app/bff/models/aa/aaGetcaptcha';
import { AaCaptchaVerifyReq, AaCaptchaVerifyResp } from 'app/bff/models/aa/aaCaptchaVerify';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq, AaOtpVerifyResp } from 'app/bff/models/aa/aaOtpVerify';
import { AaSigninReq, AaSigninResp } from 'app/bff/models/aa/aaSignin';
import { InfoGetlinkUrlReq, InfoGetlinkUrlResp } from 'app/bff/models/info/infoGetlinkUrl';
import { InfoGetbannerReq, InfoGetbannerResp } from 'app/bff/models/info/infoGetbanner';
import { InfoGetproductfeatureReq, InfoGetproductfeatureResp } from 'app/bff/models/info/infoGetproductfeature';
import { InfoGetpagephraseReq, InfoGetpagephraseResp } from 'app/bff/models/info/infoGetpagephrase';
import { InfoGetrecomplanReq, InfoGetrecomplanResp } from 'app/bff/models/info/infoGetrecomplan';
import { InfoGetqaReq, InfoGetqaResp } from 'app/bff/models/info/infoGetqa';
import { InfoGetproductReq, InfoGetproductResp } from 'app/bff/models/info/infoGetproduct';
import { InfoGetannounceReq, InfoGetannounceResp } from 'app/bff/models/info/infoGetannounce';
import { InfoGetinsuprodReq, InfoGetinsuprodResp } from 'app/bff/models/info/infoGetinsuprod';
import { InfoGetstepsReq, InfoGetstepsResp } from 'app/bff/models/info/infoGetsteps';
import { InfoGetnewslistReq, InfoGetnewslistResp } from 'app/bff/models/info/infoGetnewslist';
import { PolicyPolistReq, PolicyPolistResp } from 'app/bff/models/policy/policyPolist';
import { PolicyPodetailReq, PolicyPodetailResp } from 'app/bff/models/policy/policyPodetail';
import { PremiumEvalCalculateTravelReq, PremiumEvalCalculateTravelResp } from 'app/bff/models/premiumEval/premiumEvalCalculateTravel';
import { InfoTravelregionQueryReq, InfoTravelregionQueryResp } from 'app/bff/models/info/infoTravelregionQuery';
import { ProductGetcoverageReq, ProductGetcoverageResp } from 'app/bff/models/product/productGetcoverage';
import { ProductGetkycquestionReq, ProductGetkycquestionResp } from 'app/bff/models/product/productGetkycquestion';
import { ProductPolicyRulevalidateReq, ProductPolicyRulevalidateResp } from 'app/bff/models/product/productPolicyRulevalidate';
import { PolicyTravelReq, PolicyTravelResp } from 'app/bff/models/policy/policyTravel';
import { PolicyInsuredEncertlistReq, PolicyInsuredEncertlistResp } from 'app/bff/models/policy/policyInsuredEncertlist';
import { PolicyAmendTravelperiodReq, PolicyAmendTravelperiodResp } from 'app/bff/models/policy/policyAmendTravelperiod';
import { PolicyTravelPocancelReq, PolicyTravelPocancelResp } from 'app/bff/models/policy/policyTravelPocancel';
import { PolicyEncertlistReq, PolicyEncertlistResp } from 'app/bff/models/policy/policyEncertlist';
import { InfoGetmsgtextReq, InfoGetmsgtextResp } from 'app/bff/models/info/infoGetmsgtext';
import { InfoAddressGetaddrlistReq, InfoAddressGetaddrlistResp } from 'app/bff/models/info/infoAddressGetaddrlist';
import { InfoGetnationlistReq, InfoGetnationlistResp } from 'app/bff/models/info/infoGetnationlist';
import { PolicyGenerateInscertenReq, PolicyGenerateInscertenResp } from 'app/bff/models/policy/policyGenerateInscerten';
import { InfoSysparamsReq, InfoSysparamsResp } from 'app/bff/models/info/infoSysparams';
import { InfoSysoptsReq, InfoSysoptsResp } from 'app/bff/models/info/infoSysopts';
import { InfoAddressGetcityareaReq, InfoAddressGetcityareaResp } from 'app/bff/models/info/infoAddressGetcityarea';
import { MbRegisterReq, MbRegisterResp } from 'app/bff/models/mb/mbRegister';
import { MbGetinfoReq, MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';
import { MbUpdateinfoReq, MbUpdateinfoResp } from '../models/mb/mbUpdateinfo';
import { MbSignoutReq, MbSignoutResp } from 'app/bff/models/mb/mbSignout';
import { MbIsexistReferrerReq, MbIsexistReferrerResp } from 'app/bff/models/mb/mbIsexistReferrer';
import { MbPoreissueReq, MbPoreissueResp } from 'app/bff/models/mb/mbPoreissue';
import { MbGetreferralcodeReq, MbGetreferralcodeResp } from 'app/bff/models/mb/mbGetreferralcode';
import { PaymentCreditReq, PaymentCreditResp } from 'app/bff/models/payment/paymentCredit';
import { PaymentCreditAuthReq, PaymentCreditAuthResp } from 'app/bff/models/payment/paymentCreditAuth';
import { InfoBanklistReq, InfoBanklistResp } from 'app/bff/models/info/infoBanklist';
import { EbillPreprocReq, EbillPreprocResp } from 'app/bff/models/ebill/ebillPreproc';
import { PolicyPaymentrecordReq, PolicyPaymentrecordResp } from 'app/bff/models/policy/policyPaymentrecord';
import { MbSigninReq, MbSigninResp } from '../models/mb/mbSignin';
import { InfoJobReq, InfoJobResp } from '../models/info/infoJob';
import { InspectUsrmomaReq, InspectUsrmomaResp } from 'app/bff/models/inspect/inspectUsrmoma';
import { PaymentPayresultReq, PaymentPayresultResp } from '../models/payment/paymentPayresult';
import { AaCaptchaVoiceReq, AaCaptchaVoiceResp } from '../models/aa/aaCaptchaVoice';
import commonService from 'app/core/services/commonService';

export default {
  /**
   * @description [POST] AA#001 取得圖形驗證碼
   */
  postAaGetcaptcha: async (args: AaGetcaptchaReq) => {
    const argsModel = combineBaseReq<AaGetcaptchaReq>({}, args);
    return axios.post<BaseResp<AaGetcaptchaResp>>('/aa/getcaptcha', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] AA#002 驗證圖形驗證碼
   */
  postAaCaptchaVerify: async (args: AaCaptchaVerifyReq) => {
    const argsModel = combineBaseReq<AaCaptchaVerifyReq>({}, args);
    return axios.post<BaseResp<AaCaptchaVerifyResp>>('/aa/captcha/verify', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.verifyResult : null);
  },
  /**
   * @description [POST] AA#003 發送 OTP 驗證碼
   */
  postAaOtpSendcode: async (args: AaOtpSendcodeReq) => {
    const argsModel = combineBaseReq<AaOtpSendcodeReq>({}, args);
    return axios.post<BaseResp<AaOtpSendcodeResp>>('/aa/otp/sendcode', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] AA#004 驗證 OTP 驗證碼
   */
  postAaOtpVerify: async (args: AaOtpVerifyReq) => {
    const argsModel = combineBaseReq<AaOtpVerifyReq>({}, args);
    return axios.post<BaseResp<AaOtpVerifyResp>>('/aa/otp/verify', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] AA#005 驗證會員帳號及密碼是否正確
   */
  postAaSignin: async (args: AaSigninReq) => {
    const argsModel = combineBaseReq<AaSigninReq>({}, args);
    return axios.post<BaseResp<AaSigninResp>>('/aa/signin', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] AA#024 取得圖形驗證碼語音
   */
  postAaCaptchaVoice: async (args: AaCaptchaVoiceReq) => {
    const argsModel = combineBaseReq<AaCaptchaVoiceReq>({}, args);
    return axios.post<BaseResp<AaCaptchaVoiceResp>>('/aa/captcha/voice', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] AT#006 網投會員即時檢核
   */
  postInspectUsrmoma: async (args: InspectUsrmomaReq) => {
    const argsModel = combineBaseReq<InspectUsrmomaReq>({}, args);
    return axios.post<BaseResp<InspectUsrmomaResp>>('/inspect/usrmoma', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] UR#009 前台會員登入(合併)
   */
  postMbSignin: async (args: MbSigninReq) => {
    const argsModel = combineBaseReq<MbSigninReq>({}, args);
    return axios.post<BaseResp<MbSigninResp>>('/mb/signin', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] PC#001 取得 Header、Footer 資料
   */
  postInfoGetlinkUrl: async (args: InfoGetlinkUrlReq) => {
    const argsModel = combineBaseReq<InfoGetlinkUrlReq>({}, args);
    return axios.post<BaseResp<InfoGetlinkUrlResp>>('/info/getlinkUrl', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] PC#002 取得 Banner 資料
   */
  postInfoGetbanner: async (args: InfoGetbannerReq) => {
    const argsModel = combineBaseReq<InfoGetbannerReq>({}, args);
    return axios.post<BaseResp<InfoGetbannerResp>>('/info/getbanner', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.banner : []);
  },
  /**
   * @description [POST] PC#003 取得指定險種商品特色資料
   */
  postInfoGetproductfeature: async (args: InfoGetproductfeatureReq) => {
    const argsModel = combineBaseReq<InfoGetproductfeatureReq>({}, args);
    return axios.post<BaseResp<InfoGetproductfeatureResp>>('/info/getproductfeature', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] PC#004 取得頁面文案資料
   */
  postInfoGetpagephrase: async (args: InfoGetpagephraseReq) => {
    const argsModel = combineBaseReq<InfoGetpagephraseReq>({}, args);
    return axios.post<BaseResp<InfoGetpagephraseResp>>('/info/getpagephrase', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.limitations : []);
  },
  /**
   * @description [POST] PC#006 取得熱門推薦方案
   */
  postInfoGetrecomplan: async (args: InfoGetrecomplanReq) => {
    const argsModel = combineBaseReq<InfoGetrecomplanReq>({}, args);
    return axios.post<BaseResp<InfoGetrecomplanResp>>('/info/getrecomplan', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.recommendPlans : []);
  },
  /**
   * @description [POST] PC#007 取得指定險種小百科資料
   */
  postInfoGetqa: async (args: InfoGetqaReq) => {
    const argsModel = combineBaseReq<InfoGetqaReq>({}, args);
    return axios.post<BaseResp<InfoGetqaResp>>('/info/getqa', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] PC#008 取得指定險種商品清單 (含底圖、連結)
   */
  postInfoGetproduct: async () => {
    const argsModel = combineBaseReq<InfoGetproductReq>({}, {});
    return axios.post<BaseResp<InfoGetproductResp>>('/info/getproduct', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.products : []);
  },
  /**
   * @description [POST] PC#010 查詢公告資料
   */
  postInfoGetannounce: async () => {
    const argsModel = combineBaseReq<InfoGetannounceReq>({}, {});
    return axios.post<BaseResp<InfoGetannounceResp>>('/info/getannounce', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.insurances : []);
  },
  /**
   * @description [POST] PC#011 取得險種及險種下之商品資料
   */
  postInfoGetinsuprod: async (args: InfoGetinsuprodReq) => {
    const argsModel = combineBaseReq<InfoGetinsuprodReq>({}, args);
    return axios.post<BaseResp<InfoGetinsuprodResp>>('/info/getinsuprod', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.insurances : []);
  },
  /**
   * @description [POST] PC#012 取得投保步驟資料
   */
  postInfoGetsteps: async (args: InfoGetstepsReq) => {
    const argsModel = combineBaseReq<InfoGetstepsReq>({}, args);
    return axios.post<BaseResp<InfoGetstepsResp>>('/info/getsteps', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.insureSteps : []);
  },
  /**
   * @description [POST] PC#013 查詢最新消息列表資料
   */
  postInfoGetnewslist: async (sortPage: SortPageReq, args: InfoGetnewslistReq) => {
    const argsModel = combineBaseReq<InfoGetnewslistReq>({ sortPage }, args);
    return axios.post<BaseResp<InfoGetnewslistResp>>('/info/getnewslist', argsModel)
      .then((response) => checkHttpResponse(response) ? { sortPage: response.data.respHeader.sortPage, data: response.data.transResp.news } : null);
  },
  /**
   * @description [POST] PC#014 查詢保單列表
   */
  postPolicyPolist: async (args: PolicyPolistReq) => {
    const argsModel = combineBaseReq<PolicyPolistReq>({}, args);
    return axios.post<BaseResp<PolicyPolistResp>>('/policy/polist/travel', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.policyTravel : []);
  },
  /**
   * @description [POST] PC#015 查詢保單明細
   */
  postPolicyPodetail: async (args: PolicyPodetailReq) => {
    const argsModel = combineBaseReq<PolicyPodetailReq>({}, args);
    return axios.post<BaseResp<PolicyPodetailResp>>('/policy/podetail/travel', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.policyTravel : null);
  },
  postPolicyProtectPodetail: async (args: PolicyPodetailReq) => {
    const argsModel = combineBaseReq<PolicyPodetailReq>({}, args);
    return axios.post<BaseResp<PolicyPodetailResp>>('/policy/podetail/protect', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.policyProtect : null);
  },
  /**
   * @description [POST] IR#001 旅遊險保費計算
   */
  postPremiumEvalCalculateTravel: async (args: PremiumEvalCalculateTravelReq) => {
    const argsModel = combineBaseReq<PremiumEvalCalculateTravelReq>({}, args);
    return axios.post<BaseResp<PremiumEvalCalculateTravelResp>>('/premiumEval/calculate/travel', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] IR#002 取得旅遊地區選項
   */
  postInfoTravelregionQuery: async () => {
    const argsModel = combineBaseReq<InfoTravelregionQueryReq>({}, {});
    return axios.post<BaseResp<InfoTravelregionQueryResp>>('/info/travelregion/query', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.geoCountrys : []);
  },
  /**
   * @description [POST] IR#005 取得商品保障內容含保額檔次及保額計算公式
   */
  postProductGetcoverage: async (args: ProductGetcoverageReq) => {
    const argsModel = combineBaseReq<ProductGetcoverageReq>({}, args);
    return axios.post<BaseResp<ProductGetcoverageResp>>('/product/getcoverage', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.coverageTravel : []);
  },
  /**
   * @description [POST] IR#006 取得指定險種、商品之保險需求及適合度評估問卷資料
   */
  postProductGetkycquestion: async (args: ProductGetkycquestionReq) => {
    const argsModel = combineBaseReq<ProductGetkycquestionReq>({}, args);
    return axios.post<BaseResp<ProductGetkycquestionResp>>('/product/getkycquestion', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.questionnaires : []);
  },
  /**
   * @description [POST] IR#008 保單規則檢核
   */
  postProductPolicyRulevalidate: async (args: ProductPolicyRulevalidateReq) => {
    const argsModel = combineBaseReq<ProductPolicyRulevalidateReq>({}, args);
    return axios.post<BaseResp<ProductPolicyRulevalidateResp>>('/product/policy/rulevalidate', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] IR#014 新增旅遊險保單
   */
  postPolicyTravel: async (args: PolicyTravelReq) => {
    const argsModel = combineBaseReq<PolicyTravelReq>({}, args);
    return axios.post<BaseResp<PolicyTravelResp>>('/policy/travel', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] IR#015 查詢被保險人英文投保證明資料
   */
  postPolicyInsuredEncertlist: async (args: PolicyInsuredEncertlistReq) => {
    const argsModel = combineBaseReq<PolicyInsuredEncertlistReq>({}, args);
    return axios.post<BaseResp<PolicyInsuredEncertlistResp>>('/policy/insured/encertlist', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.policyInsured : []);
  },
  /**
   * @description [POST] IR#017 旅遊險保期修改
   */
  postPolicyAmendTravelperiod: async (args: PolicyAmendTravelperiodReq) => {
    const argsModel = combineBaseReq<PolicyAmendTravelperiodReq>({}, args);
    return axios.post<BaseResp<PolicyAmendTravelperiodResp>>('/policy/amend/travelperiod', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] IR#018 取消旅遊險保單
   */
  postPolicyTravelPocancel: async (args: PolicyTravelPocancelReq) => {
    const argsModel = combineBaseReq<PolicyTravelPocancelReq>({}, args);
    return axios.post<BaseResp<PolicyTravelPocancelResp>>('/policy/travel/pocancel', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] IR#026 新增 (更新) 被保險人英文投保證明資料
   */
  postPolicyEncertlist: async (args: PolicyEncertlistReq) => {
    const argsModel = combineBaseReq<PolicyEncertlistReq>({}, args);
    return axios.post<BaseResp<PolicyEncertlistResp>>('/policy/encertlist', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] CM#004 查詢畫面顯示訊息
   */
  postInfoGetmsgtext: async (args: InfoGetmsgtextReq) => {
    const sortPage: SortPageReq = { page: 1, size: 10000 };
    const argsModel = combineBaseReq<InfoGetmsgtextReq>({ sortPage }, args);
    return axios.post<BaseResp<InfoGetmsgtextResp>>('/info/getmsgtext', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.msgList : []);
  },
  /**
   * @description [POST] CM#005 取得街/路名稱資訊
   */
  postInfoAddressGetaddrlist: async (args: InfoAddressGetaddrlistReq) => {
    const argsModel = combineBaseReq<InfoAddressGetaddrlistReq>({}, args);
    return axios.post<BaseResp<InfoAddressGetaddrlistResp>>('/info/address/getaddrlist', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.data : []);
  },
  /**
   * @description [POST] CM#006 取得國家名稱、代號
   */
  postInfoGetnationlist: async (args: InfoGetnationlistReq) => {
    const argsModel = combineBaseReq<InfoGetnationlistReq>({}, args);
    return axios.post<BaseResp<InfoGetnationlistResp>>('/info/getnationlist', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.countries : []);
  },
  /**
   * @description [POST] CM#007 套印英文投保證明
   */
  postPolicyGenerateInscerten: async (args: PolicyGenerateInscertenReq) => {
    const argsModel = combineBaseReq<PolicyGenerateInscertenReq>({}, args);
    return axios.post<BaseResp<PolicyGenerateInscertenResp>>('/policy/generate/inscerten', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] CM#008 查詢系統參數
   */
  postInfoSysparams: async (args: InfoSysparamsReq) => {
    const argsModel = combineBaseReq<InfoSysparamsReq>({}, args);
    return axios.post<BaseResp<InfoSysparamsResp>>('/info/sysParams', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.enum : []);
  },
  /**
   * @description [POST] CM#009 查詢系統共用選項資料
   */
  postInfoSysopts: async (args: InfoSysoptsReq) => {
    const argsModel = combineBaseReq<InfoSysoptsReq>({}, args);
    return axios.post<BaseResp<InfoSysoptsResp>>('/info/sysopts', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.enum : []);
  },
  /**
   * @description [POST] CM#012 查詢郵遞區號列表
   */
  postInfoAddressGetcityarea: async () => {
    const argsModel = combineBaseReq<InfoAddressGetcityareaReq>({}, {});
    return axios.post<BaseResp<InfoAddressGetcityareaResp>>('/info/address/getcityarea', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.postcodes : []);
  },
  /**
   * @description [POST]
   */
  postInfoGetJobs: async () => {
    const argsModel = combineBaseReq<InfoJobReq>({}, {});
    return axios.post<BaseResp<InfoJobResp>>('/info/jobs', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.jobs : []);
  },
  /**
   * @description [POST] UR#001 新增會員資料
   */
  postMbRegister: async (args: MbRegisterReq) => {
    const argsModel = combineBaseReq<MbRegisterReq>({}, args);
    return axios.post<BaseResp<MbRegisterResp>>('/mb/register', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] UR#002 取得會員資料
   */
  postMbGetinfo: async (args: MbGetinfoReq) => {
    const argsModel = combineBaseReq<MbGetinfoReq>({}, args);
    return axios.post<BaseResp<MbGetinfoResp>>('/mb/getinfo', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] UR#003 更新會員資料
   */
  postMbUpdateinfo: async (args: MbUpdateinfoReq, config?: AxiosRequestConfig) => {
    const argsModel = combineBaseReq<MbUpdateinfoReq>({}, args);
    return axios.post<BaseResp<MbUpdateinfoResp>>('/mb/updateinfo', argsModel, config)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] UR#005 會員登出
   */
  postMbSignout: async (args: MbSignoutReq) => {
    const argsModel = combineBaseReq<MbSignoutReq>({}, args);
    return axios.post<BaseResp<MbSignoutResp>>('/mb/signout', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] UR#006 檢核推薦人代號是否存在
   */
  postMbIsexistReferrer: async (args: MbIsexistReferrerReq) => {
    const argsModel = combineBaseReq<MbIsexistReferrerReq>({}, args);
    return axios.post<BaseResp<MbIsexistReferrerResp>>('/mb/isexist/referrer', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.isReferrerCode : null);
  },
  /**
   * @description [POST] UR#007 保單補寄功能 (查詢 & 申請)
   */
  postMbPoreissue: async (args: MbPoreissueReq) => {
    const argsModel = combineBaseReq<MbPoreissueReq>({}, args);
    return axios.post<BaseResp<MbPoreissueResp>>('/mb/poreissue', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] UR#008 取得會員推薦碼
   */
  postMbGetreferralcode: async (args: MbGetreferralcodeReq) => {
    const argsModel = combineBaseReq<MbGetreferralcodeReq>({}, args);
    return axios.post<BaseResp<MbGetreferralcodeResp>>('/mb/getreferralcode', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] PA#002 檢核信用卡卡號
   */
  postPaymentCredit: async (args: PaymentCreditReq) => {
    const argsModel = combineBaseReq<PaymentCreditReq>({}, args);
    return axios.post<BaseResp<PaymentCreditResp>>('/check/creditCard', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [POST] PA#004 取得 NCCC 信用卡授權
   */
  postPaymentCreditAuth: async (args: PaymentCreditAuthReq) => {
    const argsModel = combineBaseReq<PaymentCreditAuthReq>({}, args);
    return axios.post<BaseResp<PaymentCreditAuthResp>>('/payment/credit/auth', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data : null);
  },
  /**
   * @description [POST] PA#006 查詢銀行清單
   */
  postInfoBanklist: async (args: InfoBanklistReq) => {
    const argsModel = combineBaseReq<InfoBanklistReq>({}, args);
    return axios.post<BaseResp<InfoBanklistResp>>('/info/banklist', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.bank : []);
  },
  /**
   * @description [POST] PA#008 全國繳費網 (e-bill) Websocket 連線通知
   */
  postEbillPreproc: async (args: EbillPreprocReq) => {
    const argsModel = combineBaseReq<EbillPreprocReq>({}, args);
    return axios.post<BaseResp<EbillPreprocResp>>('/ebill/preproc', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description [TEST]
   */
  postEbillTest: async (args: any) => {
    const argsModel = combineBaseReq({}, args);
    return axios.post('/ebill/test', argsModel)
      .then((response) => response);
  },
  /**
   * @description [POST] PA#011 查詢保單繳費資料
   */
  postPolicyPaymentrecord: async (args: PolicyPaymentrecordReq) => {
    const argsModel = combineBaseReq<PolicyPaymentrecordReq>({}, args);
    return axios.post<BaseResp<PolicyPaymentrecordResp>>('/policy/paymentrecord', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.paymentRecord : null);
  },
  postForNoteReplay: async (args: any) => {
    const argsModel = combineBaseReq<any>({}, args);
    return axios.post<BaseResp<any>>('/policy/note/replay', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp.noteCode : '');
  },
  /**
   * @description [POST] PA#021 繳費結果查詢
   */
  postPaymentPayresult: async (args: PaymentPayresultReq) => {
    const argsModel = combineBaseReq<PaymentPayresultReq>({}, args);
    return axios.post<BaseResp<PaymentPayresultResp>>('/payment/payresult', argsModel)
      .then((response) => checkHttpResponse(response) ? response.data.transResp : null);
  },
  /**
   * @description PA#021 模擬繳費結果查詢
   * @param orderId 訂單編號
   */
  mockPaymentPayresult: async (orderId: string) => {
    const response: PaymentPayresultResp = {
      policySn: 'Travel1120706C00005',
      payBy: 'H',
      isSuccess: 'S',
      // isSuccess: 'F',
      orderId,
      paymentDeadline: '2024/04/30 00:00'
    };
    await commonService.delay(200);
    return response;
  }
};
